import { Component, Input } from '@angular/core';
import {
  FIRST_ROW,
  HEADER,
  SECOND_ROW,
  THIRD_ROW,
} from './contact-card.constants';

@Component({
  selector: 'app-contact-card',
  templateUrl: './contact-card.component.html',
  styleUrls: ['./contact-card.component.scss'],
  standalone: false,
})
export class ContactCardComponent {
  @Input() rowData!: string[][];

  readonly HEADER = HEADER;
  readonly FIRST_ROW = FIRST_ROW;
  readonly SECOND_ROW = SECOND_ROW;
  readonly THIRD_ROW = THIRD_ROW;
}
